/**
 * Brainbox scopes: the `vfs` port request (wavebox_infinity
 * `docs/plans/active/brainbox-scopes.md`, section 5.3).
 *
 * The server builds every request, roots included; this only carries it to
 * the extension and turns a failure into a reply of the same shape, so the
 * server always hears back. Only an extension that lists `vfs1` is asked.
 */

/**
 * @param {Object} request - a `VfsRequest` from the server
 * @param {Object} deps - how to reach the extension
 * @param {(type: string, data: *) => Promise<*>} deps.request - `BrainboxPort.request`
 * @param {(name: string) => boolean} deps.hasFeature - the bridge feature check
 * @returns {Promise<Object>} a `VfsReply`
 */
export async function vfsReply (request, { request: send, hasFeature }) {
  if (!hasFeature('vfs1')) {
    return errorReply('This Wavebox cannot look things up')
  }
  try {
    const reply = await send('vfs', request)
    return reply && typeof reply === 'object' && typeof reply.ok === 'boolean'
      ? reply
      : errorReply('No reply')
  } catch (error) {
    return errorReply(error?.message || String(error))
  }
}

function errorReply (message) {
  return { ok: false, error: { code: 'invalid', message } }
}
